import { render, staticRenderFns } from "./tmBeatAnchor.vue?vue&type=template&id=b32760d6&functional=true&"
import script from "./tmBeatAnchor.vue?vue&type=script&lang=js&"
export * from "./tmBeatAnchor.vue?vue&type=script&lang=js&"
import style0 from "./tmBeatAnchor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports